export interface BooleanApiResponse {
    value: boolean;
}

export const parseApiResponse = (data: Record<string, unknown>): BooleanApiResponse => {
    const apiResponse: Partial<BooleanApiResponse> = {
        value: data.value ? Boolean(data.value) : false,
    };

    return {
        ...(apiResponse as BooleanApiResponse),
    };
};
